/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationActionsBase {
    getFixupPrototypeFunction() { return RecommendationActionsBase.fixupPrototype; }

    static newInstance(model: Partial<RecommendationActionsBase>): RecommendationActionsBase {
        let obj = Object.assign(new RecommendationActionsBase(), model);
        RecommendationActionsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationActionsBase>): RecommendationActionsBase {
        if (!model) return null;
        return RecommendationActionsBase.newInstance(<RecommendationActionsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationActionsBase) {
        if (!obj) return;

        models.RecommendationActionsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationActionsBase): boolean {
        Object.setPrototypeOf(obj, RecommendationActionsBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.default_params_for_action) {
            for (let val of this.default_params_for_action) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the recommendation action
     */
    name: string;

    /**
     * Description of the recommendation action
     */
    description: string;

    /**
     * Indicates the action for the resource recommendation
     */
    action_type: models.ResourceRecommendationSupportedAction;

    /**
     * action resource name mapped to template for recommendation
     */
    action_resource_name: string;

    /**
     * List of tag key/value pairs
     */
    default_params_for_action: Array<models.KeyValuePair>;

}
